import {initializeApp} from 'firebase/app'
import {getFirestore} from 'firebase/firestore'
import {getAuth} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB4iavJixKc55owUE5Po_KeMrPxs8mZCMo",
  authDomain: "cooking-with-eugenie-cfeb5.firebaseapp.com",
  projectId: "cooking-with-eugenie-cfeb5",
  storageBucket: "cooking-with-eugenie-cfeb5.appspot.com",
  messagingSenderId: "30767042980",
  appId: "1:30767042980:web:8027559d9ff5611c047131"
};

// init firebase
initializeApp(firebaseConfig)
// init firestore
const db = getFirestore()
// init auth
const auth = getAuth()

export {db, auth}
